import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import {CollapsibleList as RmwcCollapsibleList} from '@rmwc/list'
import '@rmwc/list/styles'

const StyledRmwcCollapsibleList = styled(RmwcCollapsibleList)`
  &&& .rmwc-collapsible-list__handle .mdc-list-item__meta {
    display: none;
  }
  &&& .rmwc-collapsible-list__handle:hover .mdc-list-item__meta,
  &&& .rmwc-collapsible-list__handle:focus .mdc-list-item__meta,
  &&& .rmwc-collapsible-list__handle:active .mdc-list-item__meta {
    display: initial;
  }
  &&&.rmwc-collapsible-list--open > .rmwc-collapsible-list__handle .mdc-list-item__meta {
    display: initial;
  }
`

const DrawerCollapsibleList = ({children, ...otherProps}) => <StyledRmwcCollapsibleList {...otherProps}>{children}</StyledRmwcCollapsibleList>

DrawerCollapsibleList.propTypes = {
  children: PropTypes.any,
  defaultOpen: PropTypes.bool,
  handle: PropTypes.element,
  onClose: PropTypes.func,
  onOpen: PropTypes.func,
  open: PropTypes.bool
}

export {DrawerCollapsibleList}
